import React from "react";
var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import { memo, useRef, useMemo } from "react";
import { useRouter } from "next/router";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import Modal from "../common/Modal";
import VolumeSweepImaging from "./VolumeSweepImaging";
import FourteenPointProtocol from "./FourteenPointProtocol";
import MediastinalProtocol from "./MediastinalProtocol";
import { useScanAssist } from "./hooks/useScanAssist";
import MenuView from "./views/MenuView";
import ScanAssistLandingView from "./views/ScanAssistLandingView";
import EnterCountView from "./views/EnterCountView";
var ScanAssistModal = /*#__PURE__*/memo(function ScanAssistModal() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var router = useRouter();
  var patient_uid = get(router, ["query", "params", 0]);
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isScanAssistModalOpen: s.isScanAssistModalOpen,
        patientDetail: s.patientDetail
      };
    }),
    isScanAssistModalOpen = _useStoreState.isScanAssistModalOpen,
    patientDetail = _useStoreState.patientDetail;
  var inputRef = useRef(null);
  var _useScanAssist = useScanAssist({
      patientDetail: patientDetail,
      patient_uid: patient_uid,
      isScanAssistModalOpen: isScanAssistModalOpen,
      inputRef: inputRef
    }),
    currentView = _useScanAssist.currentView,
    shouldShowMediastinalProtocol = _useScanAssist.shouldShowMediastinalProtocol,
    scanCount = _useScanAssist.scanCount,
    handleInputChange = _useScanAssist.handleInputChange,
    handleSubmitCount = _useScanAssist.handleSubmitCount,
    isSubmittingCount = _useScanAssist.isSubmittingCount,
    isSubmitCountDisabled = _useScanAssist.isSubmitCountDisabled,
    handleClose = _useScanAssist.handleClose,
    handleEnterScanCount = _useScanAssist.handleEnterScanCount,
    handleScanAssist = _useScanAssist.handleScanAssist,
    startFullScanAssistFlow = _useScanAssist.startFullScanAssistFlow,
    setSelectedScanAssistStep = _useScanAssist.setSelectedScanAssistStep,
    selectedScanAssistStep = _useScanAssist.selectedScanAssistStep,
    onSelectStep = _useScanAssist.onSelectStep,
    jumpToVolumeSweep = _useScanAssist.jumpToVolumeSweep,
    jumpToFourteenPoint = _useScanAssist.jumpToFourteenPoint,
    jumpToMediastinalProtocol = _useScanAssist.jumpToMediastinalProtocol,
    volumeSweepZones = _useScanAssist.volumeSweepZones,
    currentZoneIndex = _useScanAssist.currentZoneIndex,
    zonePhase = _useScanAssist.zonePhase,
    isTransitioning = _useScanAssist.isTransitioning,
    handleVolumeSweepNext = _useScanAssist.handleVolumeSweepNext,
    handleVolumeSweepSkip = _useScanAssist.handleVolumeSweepSkip,
    handleJumpToVolumeSweepZone = _useScanAssist.handleJumpToVolumeSweepZone,
    protocolPoints = _useScanAssist.protocolPoints,
    currentPointIndex = _useScanAssist.currentPointIndex,
    pointPhase = _useScanAssist.pointPhase,
    isLastPointSkipped = _useScanAssist.isLastPointSkipped,
    handleProtocolNext = _useScanAssist.handleProtocolNext,
    handleProtocolSkip = _useScanAssist.handleProtocolSkip,
    handleJumpToFourteenPoint = _useScanAssist.handleJumpToFourteenPoint,
    handleProtocolComplete = _useScanAssist.handleProtocolComplete,
    mediastinalPoints = _useScanAssist.mediastinalPoints,
    currentMediastinalPointIndex = _useScanAssist.currentMediastinalPointIndex,
    mediastinalPhase = _useScanAssist.mediastinalPhase,
    isLastMediastinalPointSkipped = _useScanAssist.isLastMediastinalPointSkipped,
    handleMediastinalNext = _useScanAssist.handleMediastinalNext,
    handleMediastinalSkip = _useScanAssist.handleMediastinalSkip,
    handleMediastinalComplete = _useScanAssist.handleMediastinalComplete,
    handleJumpToMediastinalPoint = _useScanAssist.handleJumpToMediastinalPoint;
  var scanAssistMenuItems = useMemo(function () {
    return [{
      id: "volumeSweep",
      label: t("volume_sweep_imaging", "Volume Sweep Imaging"),
      onSelect: jumpToVolumeSweep
    }, {
      id: "fourteenPoint",
      label: t("fourteen_point_lung_ultrasound", "14 Point Lung Ultrasound"),
      onSelect: jumpToFourteenPoint
    }, {
      id: "mediastinal",
      label: t("mediastinal_protocol", "Mediastinal Protocol"),
      disabled: !shouldShowMediastinalProtocol,
      onSelect: jumpToMediastinalProtocol
    }, {
      id: "enterCount",
      label: t("enter_scan_count", "Enter Scan Count"),
      onSelect: handleEnterScanCount
    }];
  }, [t, shouldShowMediastinalProtocol, jumpToVolumeSweep, jumpToFourteenPoint, jumpToMediastinalProtocol, handleEnterScanCount]);
  if (!isScanAssistModalOpen || !patient_uid) return null;
  var patientIdRaw = (patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id) != null ? String(patientDetail.patient_id) : "";
  function renderContent() {
    switch (currentView) {
      case "menu":
        return /*#__PURE__*/React.createElement(MenuView, {
          patientId: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id,
          onEnterScanCount: handleEnterScanCount,
          onScanAssist: handleScanAssist,
          onClose: handleClose
        });
      case "scanAssist":
        {
          var allSteps = [{
            id: "volumeSweep",
            label: t("volume_sweep_imaging", "Volume Sweep Imaging")
          }, {
            id: "fourteenPoint",
            label: t("fourteen_point_lung_ultrasound", "14 Point Lung Ultrasound")
          }, {
            id: "mediastinal",
            label: t("mediastinal_protocol", "Mediastinal Protocol"),
            hidden: !shouldShowMediastinalProtocol
          }, {
            id: "enterCount",
            label: t("enter_scan_count", "Enter Scan Count")
          }];
          var steps = allSteps.filter(function (s) {
            return !s.hidden;
          });
          return /*#__PURE__*/React.createElement(ScanAssistLandingView, {
            patientIdRaw: patientIdRaw,
            steps: steps,
            selectedStepId: selectedScanAssistStep,
            onSelectStep: onSelectStep,
            onStartFullFlow: function onStartFullFlow() {
              setSelectedScanAssistStep("volumeSweep");
              startFullScanAssistFlow();
            },
            onClose: handleClose
          });
        }
      case "volumeSweep":
        return /*#__PURE__*/React.createElement(VolumeSweepImaging, {
          zones: volumeSweepZones,
          currentZoneIndex: currentZoneIndex,
          currentPhase: zonePhase,
          isTransitioning: isTransitioning,
          onNext: handleVolumeSweepNext,
          onSkip: handleVolumeSweepSkip,
          onJumpToZone: handleJumpToVolumeSweepZone,
          onClose: handleClose,
          menuItems: scanAssistMenuItems,
          activeMenuItemId: "volumeSweep"
        });
      case "fourteenPoint":
        return /*#__PURE__*/React.createElement(FourteenPointProtocol, {
          points: protocolPoints,
          currentPointIndex: currentPointIndex,
          currentPhase: pointPhase,
          isLastPointSkipped: isLastPointSkipped,
          isTransitioning: isTransitioning,
          onNext: handleProtocolNext,
          onSkip: handleProtocolSkip,
          onComplete: handleProtocolComplete,
          onJumpToPoint: handleJumpToFourteenPoint,
          onClose: handleClose,
          menuItems: scanAssistMenuItems,
          activeMenuItemId: "fourteenPoint"
        });
      case "mediastinalProtocol":
        return /*#__PURE__*/React.createElement(MediastinalProtocol, {
          points: mediastinalPoints,
          currentPointIndex: currentMediastinalPointIndex,
          currentPhase: mediastinalPhase,
          isLastPointSkipped: isLastMediastinalPointSkipped,
          isTransitioning: isTransitioning,
          onNext: handleMediastinalNext,
          onSkip: handleMediastinalSkip,
          onComplete: handleMediastinalComplete,
          onJumpToPoint: handleJumpToMediastinalPoint,
          onClose: handleClose,
          menuItems: scanAssistMenuItems,
          activeMenuItemId: "mediastinal"
        });
      case "enterCount":
        return /*#__PURE__*/React.createElement(EnterCountView, {
          scanCount: scanCount,
          inputRef: inputRef,
          onInputChange: handleInputChange,
          onSubmitCount: handleSubmitCount,
          isSubmitting: isSubmittingCount,
          isSubmitDisabled: isSubmitCountDisabled,
          onClose: handleClose
        });
      default:
        return /*#__PURE__*/React.createElement(MenuView, {
          patientId: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id,
          onEnterScanCount: handleEnterScanCount,
          onScanAssist: handleScanAssist,
          onClose: handleClose
        });
    }
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onClose: handleClose,
    closeOnClickAway: true,
    hideHeader: true,
    positionClassName: "sm:!items-start",
    className: "flex flex-col w-full h-full sm:w-[360px] sm:h-[800px] overflow-hidden rounded-none sm:rounded-2xl !bg-gray-900 dark:!bg-gray-900 border-gray-700 text-white"
  }, renderContent());
});
ScanAssistModal.displayName = "ScanAssistModal";
export default ScanAssistModal;